import DistrictIcon from '../assets/pin.svg';
import AirportIcon from '../assets/plain.svg';

const iconTypes = {
  district: DistrictIcon,
  airport: AirportIcon,
};

export default iconTypes;
